import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import {
  AppBar,
  Container,
  Box,
  CssBaseline,
  Toolbar,
  useMediaQuery,
  Divider,
  List,
  ListItem,
  ListItemButton, ListItemIcon, Typography, Drawer, IconButton, Card
} from '@mui/material';

// project imports
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Sidebar from "./Sidebar";
import navigation from 'menu-items';
import MenuList from "./Sidebar/MenuList";
// assets
import { IconChevronRight } from '@tabler/icons';
import { SnackbarProvider } from "notistack"
import {useState} from "react";
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import PropTypes from "prop-types";
import Header from "../MainLayout/Header";

const drawerWidth = 240;

const ProfileLayout = (props) => {
  const theme = useTheme();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        background: '#978EFB'
      }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
          borderBottom: `1px solid ${theme.palette.divider}`
        }}
      >
        <Header />
      </AppBar>
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
          height:'100vh',
          mt:11,
          ml:2,
          minWidth: '240px'
        }}
        aria-label="mailbox folders"
      >
        <Card
          sx={{
            background:'rgb(229, 226, 255)',
            height:'93.5vh',
            minWidth: '240px'
          }}
        >
          <MenuList />
        </Card>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          mt:8,
          ml:1
        }}
      >
        <Card
          sx={{
            background:'rgb(229, 226, 255)'
          }}
        >
          <Outlet />
        </Card>
      </Box>
    </Box>
  );
}

ProfileLayout.propTypes = {
  window: PropTypes.func
};

export default ProfileLayout;
